// extracted by mini-css-extract-plugin
module.exports = {"mobile-store-icon":"mobile-store_mobile-store-icon__SAGpD","step-white":"mobile-store_step-white__Jdx0m","step-midnight":"mobile-store_step-midnight__dFMIW"};